import { useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import Bg1 from 'assets/mypage/reset.avif'
import CustomInput from 'components/common/CustomInput';
import CustomButton from 'components/common/CustomButton';
import { correctPw } from 'components/common/regex';
import { toast } from 'react-toastify';
import { ReactComponent as EyeOn } from 'assets/common/eyeOn.svg'
import { ReactComponent as EyeOff } from 'assets/common/eyeOff.svg'
import axios from 'axios';

const SubAccountResetPW = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { item } = location.state || {};

    const [email, setEmail] = useState<string>('')
    const [clear, setClear] = useState<boolean>(false)
    const [pwShow1, setPwShow1] = useState<boolean>(false);
    const [pwShow2, setPwShow2] = useState<boolean>(false);
    const [pwErrors, setPwErrors] = useState({ pw1: false, pw2: false });
    const [modifyInfo, setModifyInfo] = useState({
        password: '',
        password2: '',
    })

    useEffect(() => {
        if (item) {
            setEmail(item.username)
        }
        else {
            toast.error('올바르지 않는 정보입니다.')
            setTimeout(() => {
                navigate(-1)
            }, 400)
        }
    }, [item])

    useEffect(() => {
        if (modifyInfo.password.length > 7 && modifyInfo.password2.length > 7) {
            setClear(modifyInfo.password === modifyInfo.password2 && !pwErrors.pw1 && !pwErrors.pw2);
        }
        else {
            setClear(false)
        }
    }, [modifyInfo.password, modifyInfo.password2, pwErrors])

    const resetPassword = () => {
        // 비밀번호 저장하는 로직
        const reqData = {
            userId: item.id,
            newPassword: modifyInfo.password
        }
        postReset(reqData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                toast.success('비밀번호를 재설정했습니다.')
                navigate(-1)
            }
            else {
                toast.error('비밀번호 재설정에 실패했습니다.')
            }
        })
    }

    const checkPw = (key: 'pw1' | 'pw2', pw: string) => {
        setPwErrors(prev => ({ ...prev, [key]: pw ? !correctPw(pw) : false }));
    };

    const postReset = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL}signin/reset`
        return await axios.post(url, reqData)
    }

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <div
                className="relative flex justify-center items-center bg-primary bg-cover h-60 mobile:h-30 text-white"
                style={{
                    backgroundPosition: "center",
                    backgroundImage: `url(${Bg1})`,
                }}
            >
                <div className='flex flex-col justify-center items-center gap-2'>
                    <p className='font-semibold text-32 tablet:text-2xl'>비밀번호 재설정</p>
                </div>
            </div>
            <Container className="mb-6 py-10 tablet:pt-4 h-full">
                <div className='flex flex-col justify-between bg-white mx-auto mb-10 p-10 tablet:p-4 rounded-lg max-w-[512px] min-h-[680px] tablet:min-h-0'>
                    <div className='flex flex-col gap-6'>
                        <div className='flex flex-col gap-3'>
                            <p className='font-semibold mobile:text-base text-lg'>
                                이메일
                            </p>
                            <CustomInput
                                type={'email'}
                                disabled
                                value={email}
                                autocompleteOff
                                placeholder={'아이디로 사용할 이메일을 등록해주세요'}
                                onChange={() => { }}
                            />
                        </div>

                        <div className='flex flex-col gap-3'>
                            {[1, 2].map((num) => {
                                const isShow = num === 1 ? pwShow1 : pwShow2;
                                const text = num === 1 ? '신규 비밀번호' : '신규 비밀번호 확인';
                                const setShow = num === 1 ? setPwShow1 : setPwShow2;
                                const pwKey = num === 1 ? 'password' : 'password2';
                                const pwChk = num === 1 ? pwErrors.pw1 : pwErrors.pw2;
                                const placeholder = num === 1 ? '비밀번호 입력' : '비밀번호 재확인';

                                return (
                                    <div key={num}>
                                        <p className='font-semibold mobile:text-base text-lg'>
                                            {text}
                                        </p>
                                        <div className='relative w-full' >
                                            <CustomInput
                                                type={isShow ? 'text' : 'password'}
                                                value={modifyInfo[pwKey] ?? ''}
                                                name={pwKey}
                                                error={pwChk}
                                                placeholder={placeholder}
                                                onBlur={(e) => checkPw(num === 1 ? 'pw1' : 'pw2', e.target.value)}
                                                onChange={(e) =>
                                                    setModifyInfo(p => ({
                                                        ...p,
                                                        [pwKey]: e.target.value,
                                                    }))
                                                }
                                            />
                                            <div
                                                className='top-0 right-6 absolute flex items-center h-full cursor-pointer'
                                                onClick={() => setShow((prev) => !prev)}
                                            >
                                                {isShow ? <EyeOn /> : <EyeOff />}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className='mobile:mb-3 h-10 mobile:h-8'>
                            {(
                                (modifyInfo.password.length > 0 || modifyInfo.password2.length > 0) && (
                                    (modifyInfo.password.length < 8 || modifyInfo.password2.length < 8) ||
                                    (modifyInfo.password.length >= 8 && modifyInfo.password2.length >= 8 && (pwErrors.pw1 || pwErrors.pw2)) ||
                                    (modifyInfo.password.length >= 8 && modifyInfo.password2.length >= 8 && !pwErrors.pw1 && !pwErrors.pw2 && modifyInfo.password !== modifyInfo.password2)
                                )
                            ) && (
                                    <p className="h-10 mobile:h-8 text-red mobile:text-xs text-center">
                                        {(
                                            (modifyInfo.password.length < 8 || modifyInfo.password2.length < 8) ||
                                            (modifyInfo.password.length >= 8 && modifyInfo.password2.length >= 8 && (pwErrors.pw1 || pwErrors.pw2))
                                        ) ? (
                                            <>
                                                비밀번호는 영문 대문자 숫자 특수문자를 포함한<br />
                                                8자리 이상이어야 합니다.
                                            </>
                                        ) : (
                                            <>비밀번호가 일치하지 않습니다.</>
                                        )}
                                    </p>
                                )}
                        </div>
                    </div>

                    <div className='self-end tablet:w-full'>
                        <CustomButton
                            disabled={!clear}
                            className='bg-primary'
                            title='저장하기'
                            onClick={resetPassword}
                        />
                    </div>
                </div>
            </Container>
        </PageTemplate>
    )
}

export default SubAccountResetPW